import {
  Flexbox, LoadManager, PageHeader, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import manualCastrations from '@/services/api/manualCastrations'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { confirmAlert } from 'react-confirm-alert'
import { toast } from 'react-toastify'
import AnimalCard from './AnimalCard'
import TutorCard from './TutorCard'
import CastrationCard from './CastrationCard'
import AuthorCard from './AuthorCard'
import LowIncomeCard from './LowIncomeCard'

function Show({ title }) {
  usePageTitle({ title })
  const [removing, setRemoving] = useState(false)
  const { id } = useParams()
  const history = useHistory()

  const { data, loading, error } = useAxiosRequest(manualCastrations.show, id)

  async function removeCastration() {
      try {
        setRemoving(true)
        await manualCastrations.destroy(id)
        toast.success('Castração removida com sucesso')
        history.goBack()
      } catch (e) {
        toast.error(e?.message)
        setRemoving(false)
      }
    }

    function handleRemove() {
      confirmAlert({
        title: 'Excluir castração',
        message: 'Você está certo que deseja excluir esta castração?',
        buttons: [
          { label: 'Não' },
          {
            label: 'Sim, excluir',
            className: 'bg-error',
            onClick: removeCastration,
          },
        ],
      })
    }

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        icon="fa-fw fa-2x fas fa-book-medical"
        title="Castração manual"
        subtitle="Detalhes da castração manual"
      />
      <LoadManager error={error} loading={loading}>
        {
          Boolean(data) && (
            <>
              <Styles.ActionsContainer>
                <a onClick={handleRemove} disabled={removing} className={`btn btn-error btn-sm ${removing && 'loading'}`}>
                  <i className="fas fa-trash" />
                  &nbsp;Excluir castração
                </a>
              </Styles.ActionsContainer>
              <Flexbox.Columns>
                <Flexbox.Column className="col-6 col-sm-12 my-2">
                  <AnimalCard data={data} />
                </Flexbox.Column>
                <Flexbox.Column className="col-6 col-sm-12 my-2">
                  <TutorCard data={data} />
                </Flexbox.Column>
                {
                  Boolean(data?.lowIncome) && (
                    <Flexbox.Column className="col-12 my-2">
                      <LowIncomeCard data={data} />
                    </Flexbox.Column>
                  )
                }
                <Flexbox.Column className="col-12 my-2">
                  <CastrationCard data={data} />
                </Flexbox.Column>
                <Flexbox.Column className="col-12 my-2">
                  <AuthorCard data={data} />
                </Flexbox.Column>
              </Flexbox.Columns>
            </>
          )
        }
      </LoadManager>
    </Styles.Container>
  )
}

export default Show
